import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
import _imports_0 from '@/assets/icons/arrows/arr-gray-left.svg';
const _hoisted_1 = { class: "side-box__header d-flex justify-content-between align-items-center" };
const _hoisted_2 = { class: "atom-back__inner d-flex align-items-center" };
const _hoisted_3 = ["disabled"];
const _hoisted_4 = { class: "side-box__title" };
const _hoisted_5 = { class: "side-box__content" };
import FormInput from "@/components/forms/FormInput.vue";
import { ref } from "vue";
import Save from "@/components/confirmations/save.vue";
import Info from "@/components/confirmations/info.vue";
import Error from "@/components/confirmations/error.vue";
import { useRoute } from "vue-router";
import { client } from "@/main";
export default /*@__PURE__*/ _defineComponent({
    __name: 'sendMqttMessageModal',
    props: {
        isOpen: { type: Boolean },
        device: {}
    },
    emits: ["close"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const route = useRoute();
        const placeholder = ref("");
        const payload = ref("");
        const errorsToTranslate = ref([]);
        const isConfirmationOpen = ref(false);
        const isSuccessModalOpen = ref(false);
        async function sendMessage() {
            isConfirmationOpen.value = false;
            const topic = `${route.params.customerId}.${route.params.projectId}.out.${props.device.deviceId}${placeholder.value ? `.${placeholder.value}` : ""}`;
            const payloadEncoded = btoa(payload.value);
            try {
                await client.path("/mqtt/devices/{id}/down/messages").method("post").create()({
                    topic,
                    data: payloadEncoded,
                    id: props.device.deviceId
                });
                isSuccessModalOpen.value = true;
                payload.value = "";
                placeholder.value = "";
            }
            catch (e) {
                errorsToTranslate.value = e.data.errors;
            }
        }
        return (_ctx, _cache) => {
            return (_ctx.isOpen && _ctx.device)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["side-box", { active: _ctx.isOpen }])
                }, [
                    _cache[10] || (_cache[10] = _createElementVNode("span", { class: "side-box__overlay" }, null, -1)),
                    _createElementVNode("div", {
                        class: _normalizeClass(["side-box__inner last-active", {
                                opened: _ctx.isOpen
                            }])
                    }, [
                        _createElementVNode("div", _hoisted_1, [
                            _createElementVNode("div", {
                                class: "atom-back atom-back--gray",
                                onClick: _cache[0] || (_cache[0] = ($event) => (emit('close')))
                            }, [
                                _createElementVNode("div", _hoisted_2, [
                                    _cache[9] || (_cache[9] = _createElementVNode("img", { src: _imports_0 }, null, -1)),
                                    _createElementVNode("span", null, _toDisplayString(_ctx.$t("zpet")), 1)
                                ])
                            ]),
                            _createElementVNode("button", {
                                class: "btn btn-primary",
                                onClick: _cache[1] || (_cache[1] = ($event) => (isConfirmationOpen.value = true)),
                                disabled: !payload.value
                            }, _toDisplayString(_ctx.$t("odeslat")), 9, _hoisted_3)
                        ]),
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("h2", null, _toDisplayString(_ctx.$t("PoslatZpravuDo")) + " " + _toDisplayString(_ctx.$t("zarizeniPocet")), 1),
                            _createElementVNode("h3", null, [
                                _createElementVNode("span", null, _toDisplayString(_ctx.device.custDeviceName), 1)
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_5, [
                            _createVNode(FormInput, {
                                "side-box": "",
                                value: placeholder.value,
                                label: _ctx.$t('TOPIC'),
                                onChange: _cache[2] || (_cache[2] = ($event) => (placeholder.value = $event))
                            }, null, 8, ["value", "label"]),
                            _createVNode(FormInput, {
                                "side-box": "",
                                value: payload.value,
                                label: _ctx.$t('MESSAGE_PAYLOAD'),
                                onInput: _cache[3] || (_cache[3] = ($event) => (payload.value = $event))
                            }, null, 8, ["value", "label"])
                        ])
                    ], 2),
                    _createVNode(Save, {
                        opened: isConfirmationOpen.value,
                        text: 'chceteOdeslatZpravu',
                        onYes: _cache[4] || (_cache[4] = ($event) => (sendMessage())),
                        onNo: _cache[5] || (_cache[5] = ($event) => (isConfirmationOpen.value = false))
                    }, null, 8, ["opened"]),
                    _createVNode(Info, {
                        opened: isSuccessModalOpen.value,
                        text: 'zpravaOdeslana',
                        onYes: _cache[6] || (_cache[6] = ($event) => (emit('close'))),
                        onClose: _cache[7] || (_cache[7] = ($event) => (isSuccessModalOpen.value = false))
                    }, null, 8, ["opened"]),
                    _createVNode(Error, {
                        opened: !!errorsToTranslate.value.length,
                        centered: true,
                        errors: errorsToTranslate.value,
                        onClose: _cache[8] || (_cache[8] = ($event) => (errorsToTranslate.value = []))
                    }, null, 8, ["opened", "errors"])
                ], 2))
                : _createCommentVNode("", true);
        };
    }
});
